class CatalogueFormHandler
{
    constructor(dataLayer, salesforce_form_log_url, success_page_url, salesforce_post_url_pattern, catalogue_form_id) {
        this.dataLayer = dataLayer;
        this.salesforce_form_log_url = salesforce_form_log_url;
        this.success_page_url = success_page_url;
        this.salesforce_post_url_pattern = salesforce_post_url_pattern;
        this.catalogue_form_id = catalogue_form_id;

        this.form = document.querySelector('form[data-form-id=catalogue-form]');

        this.initListeners();
        this.initRequestObserver();
    }

    handleForm() {
        const href = document.querySelector('html');
        const locale = href.getAttribute('lang');

        let event_name = 'form_download_catalogus';
        if ('fr' === locale) {
            event_name = 'form_download_catalogus_fr';
        }

        this.dataLayer.push({
            'event': event_name
        })

        const form_data = new FormData(this.form);
        form_data.append('form_name', 'catalogue_form');
        axios.post(this.salesforce_form_log_url, form_data).then(response => {
            const success = response.data.success;
            if (success) {
                console.log('form data handled');
            }
        })
    }

    initListeners() {
        this.form.addEventListener('submit', (event) => {
            this.handleForm();
        }, true);
    }

    initRequestObserver() {
        const observer = new PerformanceObserver((list) => {
            for (const entry of list.getEntries()) {
                if (
                    (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest')
                    && entry.name.startsWith(this.salesforce_post_url_pattern)
                    && entry.name.includes(this.catalogue_form_id)
                    && String(entry.responseStatus).startsWith('20')
                ) {
                    location.href = this.success_page_url;
                }
            }
        });

        observer.observe({type: 'resource', buffered: true});
    }
}

window.dataLayer = window.dataLayer || [];
new CatalogueFormHandler(window.dataLayer, salesforce_form_log_url, catalogue_success_page_url, salesforce_post_url_pattern, catalogue_form_id);
